import React, { useEffect } from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Label,
  Radio,
  Card,
} from '@resideo/blueprint-react';
import { Field } from 'formik';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const StyledCard = styled(Card)`
  border: 2px solid ${({ theme }) => theme.colors.lightenGray};
  margin-bottom: ${({ theme }) => theme.space.medium};
`;

const ShippingMethod = ({ setFieldValue }) => {
  const { t } = useTranslation();

  useEffect(() => {
    setFieldValue('shippingMethod', 'standard');
  }, [setFieldValue]);

  return (
    <Box paddingBottom={['medium', 'medium', 'large', 'large']}>
      <Heading
        paddingBottom='xSmall'
        fontSize='1.125rem'
        paddingTop='medium'
        letterSpacing='normal'>
        {t('cart.shipping.shippingMethod')}
      </Heading>
      <Text
        color='textHeading'
        paddingBottom='1rem'
        fontSize='small'
        fontStyle='italic'>
        {t('cart.shipping.shippingMethodStandersStatusText')}
      </Text>
      <StyledCard
        data-test-shipping-form-sections
        borderRadius='0.9375rem'
        padding='1.5625rem'>
        <Text color='red' paddingLeft='small' fontSize='small'></Text>
        <Field name='shippingMethod' type='radio' value='standard'>
          {({ field }) => (
            <Label marginBottom='medium' paddingTop='medium'>
              <Radio name='shippingMethod' marginRight={0} {...field} />
              <Flex fontSize='14px' justifyContent='space-between' flex={1}>
                {t('cart.shipping.standardGroundBusinessDays')}
                {/* TODO: Will this alway be $10 dollars?
                    TODO: wondering if we should add to en.js file */}
                <Text fontSize='14px'>$10.00</Text>
              </Flex>
            </Label>
          )}
        </Field>
        <Field name='shippingMethod' type='radio' value='expressSecondDay'>
          {({ field }) => (
            <Label marginBottom='small'>
              <Radio name='shippingMethod' marginRight={0} {...field} />
              <Flex fontSize='14px' justifyContent='space-between' flex={1}>
                {t('cart.shipping.domesticSecondDayAir')}
                <Text fontSize='14px'>$20.00</Text>
              </Flex>
            </Label>
          )}
        </Field>
      </StyledCard>
    </Box>
  );
};

export default ShippingMethod;
